
import List from './list';
import Package from '../models/package';
import { excuseApi } from '../commons/http';

export default class Packages extends List {
  async fetch(params = {}) {
    const queryParams = new URLSearchParams({
      per_page: params.per_page || 10,
      page: params.page || 1,
      sort_by: params.sort_by || 'id',
      sort_type: params.sort_type || 'DESC',
      ...(params.status && { status: params.status })
    }).toString();

    const res = await excuseApi({
      path: `/packages?${queryParams}`,
      method: 'GET',
    });

    if (res.status === 200) {
      this.mapData(res.data.data);
      return {
        total: res.data.total,
        page: res.data.page,
        per_page: res.data.per_page
      };
    }
    return null;
  }

  mapData(data = []) {
    for (const item of data) {
      const package_ = new Package();
      package_.mapData(item);
      this.add(package_);
    }
  }
}
